import { render, staticRenderFns } from "./Tema10.vue?vue&type=template&id=6d7ce221&lang=pug"
import script from "./Tema10.vue?vue&type=script&lang=js"
export * from "./Tema10.vue?vue&type=script&lang=js"
import style0 from "./Tema10.vue?vue&type=style&index=0&id=6d7ce221&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports